/*
* COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.

* This software is only to be used for the purpose for which it has been
* provided. No part of it is to be reproduced, disassembled, transmitted,
* stored in a retrieval system nor translated in any human or computer
* language in any way or for any other purposes whatsoever without the
* prior written consent of HSBC Holdings plc.

*/

import React from 'react';
import ItemTitle from './ItemTitle';

const CheckList = (props) => {
    const {
        i18n,
        fileList
    } = props;
    return i18n ? (
        <div className={""}>
            <ItemTitle i18n={i18n.checkListTitle}/>
            <ul>
                {
                    fileList.map((item, index) => {
                        return (
                            <li key={index} className={"checklist-li"}>
                                <span data-key={item.dataKay}>{item.name}</span>
                            </li>
                        )
                    })
                }
            </ul>
        </div>
    ) : null;
};

export default CheckList;


// WEBPACK FOOTER //
// ./src/views/Appointment/components/CheckList.js